export const INGEST_SOURCES = [
    "bulk",
    "single_vod",
    "mrss_item",
    "mrss_sync",
];
export const INGEST_TRANSCODERS = ["encore", "videocore"];
export const INGEST_SOURCE_LABEL = {
    bulk: "Bulk ingest",
    single_vod: "Single VOD",
    mrss_item: "MRSS item",
    mrss_sync: "MRSS sync",
};
export function isExternalSource(source) {
    return source === "mrss_item" || source === "mrss_sync";
}
export function isIngestSource(v) {
    return (typeof v === "string" && INGEST_SOURCES.includes(v));
}
export const INGEST_BUCKETS = [
    "queued",
    "held",
    "running",
    "failed",
    "completed",
];
export const OVERVIEW_TERMINAL_DAYS = 7;
export function isIngestBucket(v) {
    return (typeof v === "string" && INGEST_BUCKETS.includes(v));
}
